import { LOGIN_PAGE_PATH } from 'app-constants';
import {
  useCheckIsEqualCurrentPageUrl,
  useGetPageUrlSuspense,
  usePageUrlSuspenseState,
} from 'hooks';
import { type PropsWithChildren, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

type PageUrlCheckRenderProps = PropsWithChildren<{
  skipCheck?: boolean;
}>;

const createSuspensePromise = () =>
  new Promise((resolve) => setTimeout(resolve, 0));
// Component that manages page URL check and rendering
export const PageUrlCheckRender = ({
  children,
  skipCheck,
}: PageUrlCheckRenderProps) => {
  const { pathname } = useLocation();

  const prevPathname = useRef<string | null>(null);

  const isEqualCurrentPageUrl = useCheckIsEqualCurrentPageUrl();

  const { data: pageUrlData } = usePageUrlSuspenseState();

  const isPreviousAndCurrentPathLogin =
    prevPathname.current?.includes(LOGIN_PAGE_PATH) &&
    pathname.includes(LOGIN_PAGE_PATH);

  const { pageUrl, handlePageUrlQueryCompleted } = useGetPageUrlSuspense({
    skip:
      skipCheck ||
      isEqualCurrentPageUrl ||
      !!pageUrlData?.page_url?.url?.match(pathname) ||
      isPreviousAndCurrentPathLogin,
  });

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      prevPathname.current = pathname;
    }
  }, [pathname]);

  if (
    !(
      skipCheck ||
      pageUrl?.match(pathname) ||
      isEqualCurrentPageUrl ||
      !!pageUrlData?.page_url?.url?.match(pathname)
    )
  ) {
    Promise.resolve().then(() => {
      handlePageUrlQueryCompleted();
    });
    throw createSuspensePromise();
  }

  return <>{children}</>;
};
